export default function languageSelector() {
    if (document.querySelector(".language-selector")) {
        let selector = document.querySelectorAll(".language-selector");

        selector.forEach(el => {
            el.addEventListener("click", () => {
                el.classList.toggle("is-active");
            });
        });
    }
}
